import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Search News
 */
export default class NewsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Object} deps.count
   * @param {Object} deps.items
   * @param {SearchNewsPagination} deps.pagination
   */
  constructor({pageItems, page, count, items, pagination}) {
    super({
      pageItems,
      page,
      count,
      items
    })

    this._itemsPerPage = pageItems
    this._totalItems = count
    this._page = page
    this._items = items
    this._pagination = pagination
  }

  setPagination(pagination) {
    this._pagination = pagination
  }

  getTotalPages = () => Math.ceil(this._totalItems / this._itemsPerPage)

  isFirstPage = () => this._page === 1

  isLastPage = () => this._page >= this.getTotalPages()

  /**
   * @return {Object}
   */
  toJSON() {
    return {
      firstPage: this.isFirstPage(),
      lastPage: this.isLastPage(),
      totalPages: this.getTotalPages(),
      count: this._totalItems,
      items: this._items.map(item => item.toJSON()),
      pagination: this._pagination && this._pagination.toJSON()
    }
  }
}
